// extracted by mini-css-extract-plugin
export default {"sidebarLayout":"AdjustmentSlider_sidebarLayout__my8G3","mainContent":"AdjustmentSlider_mainContent__mKxwG"};